require('../brokerTransferExternalSteps.scss');
require('./brokerTransferExternalStep3.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
// @ helpers
const { FormattedText } = require('core/i18n').i18n;
// @ components
const { SignaturePattern } = require('components/signaturePattern/signaturePattern');
// @ constants
const {
    FIRST_STEP,
    BROKER_TYPE_BANK_NAME,
    BROKER_TYPE_AGENCIE,
    BROKER_CASH_CHARGE_SIGNATURE_PATTERN_PARAM
 } = require('constants/index');
const { BROKER_TRANSFER_EXTERNAL_ID } = require('constants/operationTypes');

const BrokerTransferExternalStep3 = props => {
    const { immTransferExternalValues, immTraspassFunds } = props;

    const transferType = immTransferExternalValues.getIn(['steps', FIRST_STEP, 'transferType']);
    const contractNumber = immTransferExternalValues.getIn(['steps', FIRST_STEP, 'contractNumber']);
    const selectedOption = immTransferExternalValues.getIn(['steps', FIRST_STEP, 'accountIdTo']);
    const selectedAccount = immTraspassFunds.get(selectedOption);
    const destinationAccount = BROKER_CASH_CHARGE_SIGNATURE_PATTERN_PARAM + selectedAccount.get('productNumber') + selectedAccount.get('walletNumber');
    let originAccount = '';

    if ( transferType.get(BROKER_TYPE_BANK_NAME).get('value') ) {
        originAccount = contractNumber.get('bank') + contractNumber.get('office') + contractNumber.get('contract');
    }

    if ( transferType.get(BROKER_TYPE_AGENCIE).get('value') ) {
        originAccount = immTransferExternalValues.getIn(['steps', FIRST_STEP, 'agencieContract']);
    }

    const operationParams = {
        originAccount,
        destinationAccount
    }

    return (
        <article className="broker-transfer-external-steps broker-transfer-external-step3">
            <header className="broker-transfer-external-steps__header">
                <FormattedText value="broker-transferExternalStep3Title" className="broker-transfer-external-steps__title" />

                <FormattedText value="broker-transferExternalStep3SubTitle" className="broker-transfer-external-steps__subtitle" />
            </header>
            <section className="broker-transfer-values-step__content">
                <SignaturePattern
                    operationType={BROKER_TRANSFER_EXTERNAL_ID}
                    operationParams={operationParams}
                />
            </section>
        </article>
    )
};

BrokerTransferExternalStep3.propTypes = {
    immTransferExternalValues: PropTypes.object.isRequired,
    immTraspassFunds: PropTypes.object.isRequired,
    setConfirmationCode: PropTypes.func.isRequired,
    doSendConfirmationCode: PropTypes.func.isRequired
}

module.exports = BrokerTransferExternalStep3;